export const colourOptions = [
  { value: 'red', label: 'Offline', color: '#FF5630', isFixed: true },
  { value: 'yellow', label: 'Ocupado', color: '#FFC400' },
  { value: 'green', label: 'Disponível', color: '#36B37E' },
]
